import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { fetchBySlug } from '../lib/cms';
import { Calendar, ArrowLeft, Share2 } from 'lucide-react';

const AdventureDetail = () => {
  const { slug } = useParams();
  const [adventure, setAdventure] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      const data = await fetchBySlug('da', slug);
      setAdventure(data);
      setLoading(false);
    };
    loadData();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex justify-center items-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!adventure) {
    return (
      <div className="min-h-screen flex flex-col justify-center items-center text-center px-4">
        <h1 className="text-4xl font-bold mb-4">Hov! Denne historie er svømmet væk</h1>
        <p className="text-slate-600 mb-8">Jeg kan ikke finde det eventyr, du leder efter.</p>
        <Link to="/eventyr" className="text-blue-600 font-bold flex items-center gap-2">
          <ArrowLeft className="h-5 w-5" /> Tilbage til oversigten
        </Link>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{adventure.title.da} | LimfjordsOdderen</title>
        <meta name="description" content={adventure.title.da} />
      </Helmet>

      <article className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/eventyr" className="inline-flex items-center gap-2 text-blue-600 font-medium mb-8 hover:translate-x-1 transition-transform">
            <ArrowLeft className="h-4 w-4" /> Tilbage til alle eventyr
          </Link>

          <header className="mb-12">
            <div className="flex items-center gap-4 text-slate-500 mb-6">
              <span className="flex items-center gap-2">
                <Calendar className="h-4 w-4" /> {adventure.date}
              </span>
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-slate-900 mb-8 leading-tight">
              {adventure.title.da}
            </h1>
            <div className="aspect-video rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src={adventure.image[0]} 
                alt={adventure.title.da}
                className="w-full h-full object-cover"
              />
            </div>
          </header>

          <div className="prose prose-xl prose-blue max-w-none text-slate-700 leading-relaxed">
            <div dangerouslySetInnerHTML={{ __html: adventure.content.da }} />
          </div>

          <footer className="mt-16 pt-8 border-t border-slate-200 flex justify-between items-center">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-blue-600 flex items-center justify-center text-white font-bold">
                LO
              </div>
              <div>
                <p className="font-bold text-slate-900">Skrevet af LimfjordsOdderen</p>
                <p className="text-sm text-slate-500">Professionel livsnyder</p>
              </div>
            </div>
            <button className="p-3 rounded-full bg-slate-100 hover:bg-blue-50 text-slate-600 hover:text-blue-600 transition-colors">
              <Share2 className="h-5 w-5" />
            </button>
          </footer>
        </div>
      </article>
    </>
  );
};

export default AdventureDetail;
